import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=e733b450&scoped=true"
import script from "./forgetpassword.vue?vue&type=script&lang=js"
export * from "./forgetpassword.vue?vue&type=script&lang=js"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&id=e733b450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e733b450",
  null
  
)

export default component.exports